module.exports = __webpack_public_path__ + "static/media/comment-times.56d0012e.svg";